(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  const header = document.querySelector(".section-header");
const toggleClass = "is-sticky";

window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll > 150) {
    header.classList.add(toggleClass);
  } else {
    header.classList.remove(toggleClass);
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-items"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var container = document.querySelector('[data-tabs-accordion="{{ section.id }}"]');
  if (!container) return;

  /* Desktop tabs logic */
  var tabButtons = container.querySelectorAll('.tabs-desktop-tab-{{ section.id }}');
  var tabPanels = container.querySelectorAll('.tabs-desktop-panel-{{ section.id }}');

  function activateTab(index) {
    tabButtons.forEach(function(btn, i) {
      var isActive = i === index;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    tabPanels.forEach(function(panel, i) {
      var isActive = i === index;
      panel.classList.toggle('is-active', isActive);
    });
  }

  tabButtons.forEach(function(button, index) {
    button.addEventListener('click', function() {
      activateTab(index);
    });
  });

  /* Mobile accordion logic (one open at a time) */
  var accordionTriggers = container.querySelectorAll('.accordion-trigger-{{ section.id }}');
  var accordionPanels = container.querySelectorAll('.accordion-panel-{{ section.id }}');

  function closeAllAccordions() {
    accordionTriggers.forEach(function(trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    accordionPanels.forEach(function(panel) {
      panel.style.maxHeight = null;
    });
  }

  accordionTriggers.forEach(function(trigger, index) {
    trigger.addEventListener('click', function() {
      var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        // Close current
        trigger.setAttribute('aria-expanded', 'false');
        accordionPanels[index].style.maxHeight = null;
      } else {
        // Close others, open this one
        closeAllAccordions();
        trigger.setAttribute('aria-expanded', 'true');
        var panel = accordionPanels[index];
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  // Ensure first accordion item is properly sized on load if set open
  var firstPanel = container.querySelector(
    '.accordion-panel-{{ section.id }}[style*="max-height"]'
  );
  if (firstPanel) {
    firstPanel.style.maxHeight = firstPanel.scrollHeight + 'px';
  }
});

  } catch(e) { console.error(e); }
})();
})();
